var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('export-form',{attrs:{"users":this.users,"csv":_vm.csv},on:{"export":function($event){return _vm.loadTable($event)}}}),(_vm.items.length > 0)?_c('BaseTable',{attrs:{"hover":"","items":_vm.items,"header":_vm.exportHeader}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }